import { styled } from "@mui/material";

export const IconContainer = styled("div")(() => ({
  "&> svg": {
    minWidth: "20px",
    minHeight: "20px",
  },
}));
